import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/institucional/home/Home.vue'
import RedeBaseDeDados from '../views/institucional/rede/RedeBaseDeDados.vue'
import BaseDadosNacional from '../views/institucional/base-dados-nacional/BaseDadosNacional.vue'
import PoliticaDeDados from '../views/institucional/politica-dados/PoliticaDeDados.vue'
import ComiteCientifico from '../views/institucional/comite-cientifico/ComiteCientifico.vue'
import Tutorial from '../views/institucional/tutorial/Tutorial.vue'
import EspeciesInstitucional from '../views/institucional/especies/EspeciesInstitucional.vue'
import EspeciesMarinhasInstitucional from '../views/institucional/especies-marinhas/EspeciesMarinhasInstitucional.vue'
import PeixesAquarioInstitucional from '../views/institucional/peixes-aquario/PeixesAquarioInstitucional.vue'
import PeixesAquiculturaInstitucional from '../views/institucional/peixes-aquicultura/PeixesAquiculturaInstitucional.vue'
import PescaDesportivaInstitucional from '../views/institucional/pesca-desportiva/PescaDesportivaInstitucional.vue'
import PetsInstitucional from '../views/institucional/pets/PetsInstitucional.vue'
import PlantasForrageirasInstitucional from '../views/institucional/plantas-forrageiras/PlantasForrageirasInstitucional.vue'
import PlantasOrnamentaisInstitucional from '../views/institucional/plantas-ornamentais/PlantasOrnamentaisInstitucional.vue'
import UsoFlorestalInstitucional from '../views/institucional/uso-florestal/UsoFlorestalInstitucional.vue'
import ColaboradoresInstitucional from '../views/institucional/colaboradores/ColaboradoresInstitucional.vue'
import ReferenciasInstitucional from '../views/institucional/referencias/ReferenciasInstitucional.vue'
import ProjetosInstitucional from '../views/institucional/projetos/ProjetosInstitucional.vue'
import ContatoInstitucional from '../views/institucional/contato/ContatoInstitucional.vue'
import Login from '../views/institucional/login/Login.vue'
import ExclusaoConta from '../views/institucional/exclusao-conta/ExclusaoConta.vue'
import AdminHome from '../views/admin/home/Home.vue'
import AdminColaboradores from '../views/admin/colaboradores/Colaboradores.vue'
import AdminColaboradoresForm from '../views/admin/colaboradores/ColaboradoresForm.vue'
import AdminEspecies from '../views/admin/especies/Especies.vue'
import AdminEspeciesForm from '../views/admin/especies/EspeciesForm.vue'
import AdminProjetos from '../views/admin/projetos/Projetos.vue'
import AdminProjetosForm from '../views/admin/projetos/ProjetosForm.vue'
import AdminReferencias from '../views/admin/referencias/Referencias.vue'
import AdminReferenciasForm from '../views/admin/referencias/ReferenciasForm.vue'
import AdminTaxonomia from '../views/admin/taxonomia/Taxonomia.vue'
import AdminUsuarios from '../views/admin/usuarios/Usuarios.vue'
import AdminUsuariosForm from '../views/admin/usuarios/UsuariosForm.vue'
import AdminOcorrencias from '../views/admin/ocorrencias/Ocorrencias.vue'
import AdminOcorrenciasForm from '../views/admin/ocorrencias/OcorrenciasForm.vue'
import CoralsolLocalidade from '../views/admin/coralsol/localidade/CoralsolLocalidade.vue'
import CoralsolLocalidadeForm from '../views/admin/coralsol/localidade/CoralsolLocalidadeForm.vue'
import CoralsolOcorrencias from '../views/admin/coralsol/ocorrencias/CoralsolOcorrencias.vue'
import CoralsolOcorrenciasForm from '../views/admin/coralsol/ocorrencias/CoralsolOcorrenciasForm.vue'
import CoralsolManejos from '../views/admin/coralsol/manejos/CoralsolManejos.vue'
import CoralsolManejosForm from '../views/admin/coralsol/manejos/CoralsolManejosForm.vue'
import CoralsolDaforForm from '../views/admin/coralsol/dafor/CoralsolDaforForm.vue'
import CoralsolDafor from '../views/admin/coralsol/dafor/CoralsolDafor.vue'
import FichasMMA from '../views/admin/exportarDados/fichasMMA/FichasMMA.vue'
import FichasMMA2 from '../views/admin/exportarDados/fichasMMA2/FichasMMA2.vue'
import Fichas from '../views/admin/exportarDados/fichas/Fichas.vue'
import Consultas from '../views/admin/exportarDados/consultas/Consultas.vue'
import AdminOcorrenciasApp from '../views/admin/ocorrenciasApp/OcorrenciasApp.vue'
import AdminOcorrenciasAppForm from '../views/admin/ocorrenciasApp/OcorrenciasAppForm.vue'
import AreaProtegida from '../views/admin/areaProtegida/AreaProtegida.vue'
import AreaProtegidaForm from '../views/admin/areaProtegida/AreaProtegidaForm.vue'
import Estado from '../views/admin/estado/Estado.vue'
import EstadoForm from '../views/admin/estado/EstadoForm.vue'
import Municipio from '../views/admin/municipio/Municipio.vue'
import MunicipioForm from '../views/admin/municipio/MunicipioForm.vue'
import GrupoEmails from '../views/admin/grupoEmails/GrupoEmails.vue'
import GrupoEmailsForm from '../views/admin/grupoEmails/GrupoEmailsForm.vue'
import Emails from '../views/admin/emails/Emails.vue'
import EmailsForm from '../views/admin/emails/EmailsForm.vue'
import EspecieEmail from '../views/admin/especieEmail/EspecieEmail.vue'
import EspecieEmailForm from '../views/admin/especieEmail/EspecieEmailForm.vue'

import store from '@/store'

Vue.use(VueRouter)
const basic = 'basic'
const admin = 'administrator'
const coralsoluser = 'coralsoluser'
const coralsoladmin = 'coralsoladmin'
const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/exclusao-conta',
    name: 'ExclusaoConta',
    component: ExclusaoConta,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/base-dados-nacional',
    name: 'BaseDadosNacional',
    component: BaseDadosNacional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/rede-base-de-dados',
    name: 'RedeBaseDeDados',
    component: RedeBaseDeDados,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/politica-de-dados',
    name: 'PoliticaDeDados',
    component: PoliticaDeDados,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/comite-cientifico',
    name: 'ComiteCientifico',
    component: ComiteCientifico,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: Tutorial,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/especies',
    name: 'EspeciesInstitucional',
    component: EspeciesInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/especies/:id',
    name: 'EspeciesInstitucionalById',
    component: EspeciesInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/especies-marinhas',
    name: 'EspeciesMarinhasInstitucional',
    component: EspeciesMarinhasInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/peixes-aquario',
    name: 'PeixesAquarioInstitucional',
    component: PeixesAquarioInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/peixes-aquicultura',
    name: 'PeixesAquiculturaInstitucional',
    component: PeixesAquiculturaInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/pesca-desportiva',
    name: 'PescaDesportivaInstitucional',
    component: PescaDesportivaInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/pets',
    name: 'PetsInstitucional',
    component: PetsInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/plantas-forrageiras',
    name: 'PlantasForrageirasInstitucional',
    component: PlantasForrageirasInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/plantas-ornamentais',
    name: 'PlantasOrnamentaisInstitucional',
    component: PlantasOrnamentaisInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/uso-florestal',
    name: 'UsoFlorestalInstitucional',
    component: UsoFlorestalInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/colaboradores',
    name: 'ColaboradoresInstitucional',
    component: ColaboradoresInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/referencias',
    name: 'ReferenciasInstitucional',
    component: ReferenciasInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/projetos',
    name: 'ProjetosInstitucional',
    component: ProjetosInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/contato',
    name: 'ContatoInstitucional',
    component: ContatoInstitucional,
    meta: {
      appAdmin: false
    }
  },
  {
    path: '/admin',
    name: 'AdminHome',
    component: AdminHome,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/colaboradores',
    name: 'AdminColaboradores',
    component: AdminColaboradores,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/colaboradores/:id',
    name: 'AdminColaboradoresForm',
    component: AdminColaboradoresForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/especies',
    name: 'AdminEspecies',
    component: AdminEspecies,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/especies/:id',
    name: 'AdminEspeciesForm',
    component: AdminEspeciesForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/projetos',
    name: 'AdminProjetos',
    component: AdminProjetos,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/projetos/:id',
    name: 'AdminProjetosForm',
    component: AdminProjetosForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/ocorrencias',
    name: 'AdminOcorrencias',
    component: AdminOcorrencias,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/ocorrencias/:id',
    name: 'AdminOcorrenciasForm',
    component: AdminOcorrenciasForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/coralsol/localidade',
    name: 'CoralsolLocalidade',
    component: CoralsolLocalidade,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/localidade/:id',
    name: 'CoralsolLocalidadeForm',
    component: CoralsolLocalidadeForm,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/dafor',
    name: 'CoralsolDafor',
    component: CoralsolDafor,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/dafor/:id',
    name: 'CoralsolDaforForm',
    component: CoralsolDaforForm,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/ocorrencias',
    name: 'CoralsolOcorrencias',
    component: CoralsolOcorrencias,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/ocorrencias/:id',
    name: 'CoralsolOcorrenciasForm',
    component: CoralsolOcorrenciasForm,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/manejos',
    name: 'CoralsolManejos',
    component: CoralsolManejos,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/coralsol/manejos/:id',
    name: 'CoralsolManejosForm',
    component: CoralsolManejosForm,
    meta: {
      appAdmin: true,
      role: coralsoluser
    }
  },
  {
    path: '/admin/referencias',
    name: 'AdminReferencias',
    component: AdminReferencias,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/referencias/:id',
    name: 'AdminReferenciasForm',
    component: AdminReferenciasForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/taxonomia',
    name: 'AdminTaxonomia',
    component: AdminTaxonomia,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/usuarios',
    name: 'AdminUsuarios',
    component: AdminUsuarios,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/usuarios/:id',
    name: 'AdminUsuariosForm',
    component: AdminUsuariosForm,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/exportar/fichas-mma',
    name: 'FichasMMA',
    component: FichasMMA,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/exportar/fichas-mma-v2',
    name: 'FichasMMA2',
    component: FichasMMA2,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/exportar/fichas',
    name: 'Fichas',
    component: Fichas,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/exportar/consultas',
    name: 'Consultas',
    component: Consultas,
    meta: {
      appAdmin: true,
      role: admin
    }
  },
  {
    path: '/admin/ocorrencias-app',
    name: 'AdminOcorrenciasApp',
    component: AdminOcorrenciasApp,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/ocorrencias-app/:id',
    name: 'AdminOcorrenciasAppForm',
    component: AdminOcorrenciasAppForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/area-protegida',
    name: 'AreaProtegida',
    component: AreaProtegida,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/area-protegida/:id',
    name: 'AreaProtegidaForm',
    component: AreaProtegidaForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/estado',
    name: 'Estado',
    component: Estado,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/estado/:id',
    name: 'EstadoForm',
    component: EstadoForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/municipio',
    name: 'Municipio',
    component: Municipio,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/municipio/:id',
    name: 'MunicipioForm',
    component: MunicipioForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/grupo-emails',
    name: 'GrupoEmails',
    component: GrupoEmails,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/grupo-emails/:id',
    name: 'GrupoEmailsForm',
    component: GrupoEmailsForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/emails',
    name: 'Emails',
    component: Emails,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/emails/:id',
    name: 'EmailsForm',
    component: EmailsForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/especies-email',
    name: 'EspecieEmail',
    component: EspecieEmail,
    meta: {
      appAdmin: true,
      role: basic
    }
  },
  {
    path: '/admin/especies-email/:id',
    name: 'EspecieEmailForm',
    component: EspecieEmailForm,
    meta: {
      appAdmin: true,
      role: basic
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const defaultRouter = '/login'
  const requiresAuth = to.matched.some(record => record.meta.appAdmin)
  const role = to.meta.role
  store.commit('preload', false)
  store.state.beforeRouter = from.name
  if (!((from.name === 'AdminColaboradoresForm' && to.name === 'AdminColaboradores') ||
    (from.name === 'AdminEspeciesForm' && to.name === 'AdminEspecies') ||
    (from.name === 'AdminProjetosForm' && to.name === 'AdminProjetos') ||
    (from.name === 'AdminOcorrenciasForm' && to.name === 'AdminOcorrencias') ||
    (from.name === 'AdminOcorrenciasAppForm' && to.name === 'AdminOcorrenciasApp') ||
    (from.name === 'AdminReferenciasForm' && to.name === 'AdminReferencias') ||
    (from.name === 'AdminUsuariosForm' && to.name === 'AdminUsuarios')) &&
    !((from.name === 'AdminColaboradores' && to.name === 'AdminColaboradoresForm') ||
    (from.name === 'AdminEspecies' && to.name === 'AdminEspeciesForm') ||
    (from.name === 'AdminProjetos' && to.name === 'AdminProjetosForm') ||
    (from.name === 'AdminOcorrencias' && to.name === 'AdminOcorrenciasForm') ||
    (from.name === 'AdminOcorrenciasApp' && to.name === 'AdminOcorrenciasAppForm') ||
    (from.name === 'AdminReferencias' && to.name === 'AdminReferenciasForm') ||
    (from.name === 'AdminUsuarios' && to.name === 'AdminUsuariosForm'))) {
    store.state.currentPage = 1
    store.state.perPage = 10
    store.commit('clearFormSearch')
  }
  if (requiresAuth) {
    if (!store.state.user || !store.state.user.token) {
      next(defaultRouter)
    } else {
      const userProfile = store.state.user.perfilUser
      if (role === admin && userProfile !== admin) {
        next(defaultRouter)
      } else if (role === coralsoluser && !(userProfile === admin || userProfile === coralsoladmin || userProfile === coralsoluser)) {
        next(defaultRouter)
      } else {
        store.state.logged = true
        next()
      }
    }
  } else next()
})

export default router
